import { usePageTitle, useScrollToTop } from "../hooks";
import {ArticleByRub} from "../components/sections";

const Article = () => {
    usePageTitle('Article');
    useScrollToTop();

    return (
        <div>
            <ArticleByRub />
        </div>
    );
}

export default Article;